module.exports = __webpack_public_path__ + "static/media/sl.db9f7b35.svg";